function init() {
  document.querySelectorAll('[data-price-source]').forEach(node => initBoundPrice(node));
}

function initBoundPrice(node) {
  const sourceSelector = node.dataset.priceSource;
  const source = document.querySelector(sourceSelector);
  
  if (!source) { return; }
  source.addEventListener('change', e => updatePrice(source, node));
  updatePrice(source, node);
}

function updatePrice(sourceNode, destNode) {
  if (!sourceNode) { return; }
  
  if (sourceNode.nodeName !== 'SELECT') { return; }
  
  const selectedIndex = sourceNode.selectedIndex;
  
  if (selectedIndex === null) { return; }
  
  const selectedOption = sourceNode.options[selectedIndex];
  
  if (!selectedOption) { return; }
  
  
  const price = selectedOption.dataset.price;
  destNode.innerText = price;
}


const priceBinding = { init };
export default priceBinding;